module.exports = __webpack_public_path__ + "static/img/banner2.f320d674.png";